import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';

import { IGatsbyLocalImage } from '../../types/gatsby';
import { serializeImageForImageComponent } from '../../utils/serializeImageForImageComponent';
import { Box, Flex } from '../Core/index';
import Image from '../Image';
import OutsideClick from '../OutsideClick/OutsideClick';
import StyledLink from '../StyledLink';
import Text from '../Text';
import { TEXT_STYLES } from '../Text/constants';

interface ILanguageSelectorProps {
  currentLanguage: Language;
  pageNotInOtherLanguagesMsg: string;
  translations: Queries.PageDAccueilQuery['wpPage']['translations'];
}
const LanguageSelector: FCWithClassName<ILanguageSelectorProps> = (props) => {
  const { currentLanguage, pageNotInOtherLanguagesMsg, translations } = props;
  const [isOpen, setIsOpen] = useState(false);
  const data: {
    [key: string]: IGatsbyLocalImage;
  } = useStaticQuery(graphql`
    query Flags {
      en_GB: file(relativePath: { eq: "flags/en_GB.svg" }) {
        publicURL
        extension
      }
      fr_BE: file(relativePath: { eq: "flags/fr_FR.svg" }) {
        publicURL
        extension
      }
      nl_BE: file(relativePath: { eq: "flags/nl_BE.svg" }) {
        publicURL
        extension
      }
    }
  `);

  const buttonLabel = currentLanguage.code;
  const buttonFlag = serializeImageForImageComponent({
    image: data[currentLanguage.locale],
  });

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <OutsideClick setIsOpen={setIsOpen} className="relative">
      <Box
        onClick={handleClick}
        className="px-4 pb-2 cursor-pointer select-none xl:mt-2"
      >
        <Flex direction="row" align="center">
          <Image image={buttonFlag} className="w-6" />
          <Text variant={TEXT_STYLES.H4} className="ml-3 !text-xl pt-1">
            {buttonLabel}
          </Text>
        </Flex>
      </Box>
      <Box
        className={`flex flex-col w-32 px-4  mt-3 bg-white absolute z-40  ${
          isOpen ? 'block' : 'hidden'
        }`}
      >
        {translations?.length ? (
          translations?.map((translation) => {
            if (!translation?.language) return null;
            const flag = serializeImageForImageComponent({
              image: data[translation.language.locale],
            });
            return (
              <StyledLink
                key={translation.language.code}
                to={translation.uri?.replace('equipe/', 'staff/')}
                variant="navigationLink"
                className="text-xl"
              >
                <Flex direction="row" align="center">
                  <Image image={flag} className="w-6" />
                  <Text
                    variant={TEXT_STYLES.H4}
                    className="ml-3 mt-1.5 !text-xl text-text"
                  >
                    {translation.language.code}
                  </Text>
                </Flex>
              </StyledLink>
            );
          })
        ) : (
          <Text className="text-right">{pageNotInOtherLanguagesMsg}</Text>
        )}
      </Box>
    </OutsideClick>
  );
};

export default LanguageSelector;
